<div class="info">
  <div class="info__panel">
    <div class="info__icon" aria-hidden="true">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"/>
      </svg>
    </div>
    <h2 class="info__title cr-display">{{ node.title }}</h2>
    <p class="info__content">{{ node.content }}</p>
    <button type="button" class="info__cta" (click)="acknowledge()">
      {{ node.ctaLabel || 'Verstanden, weiter' }}
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M5 12h14M13 5l7 7-7 7"/>
      </svg>
    </button>
  </div>
</div>
